export const StudentBookedTutorToSupport = (data) => {
  return `<table align="center" width="100%" data-id="react-email-section" border="0" cellPadding="0" cellSpacing="0"
role="presentation" style="padding-left:1.5rem;padding-right:1.5rem;padding-top:2rem;padding-bottom:2rem">
<tbody>
  <tr>
    <td>
      <p data-id="react-email-text"
        style="font-size:2.25rem;line-height:44px;margin:16px 0;color:rgb(52,64,84);font-weight:600;letter-spacing:-0.025em;margin-top:0px;margin-bottom:1.5rem">
        Dear Support Team,</p>
      <p data-id="react-email-text"
        style="font-size:1.125rem;line-height:1.75rem;margin:16px 0;color:rgb(52,64,84);font-weight:400">Student ${data?.studentName} has booked a tutoring session with tutor ${data?.tutorName}</p>
      <p data-id="react-email-text"
        style="font-size:1.125rem;line-height:1.75rem;margin:16px 0;color:rgb(52,64,84);font-weight:600">Session
        Details:</p>
      <p data-id="react-email-text"
        style="font-size:1.125rem;line-height:1.75rem;margin:16px 0;color:rgb(52,64,84);font-weight:400"></p>
      <table cellSpacing="0" cellPadding="0">
        <tr style="color:rgb(52,64,84);font-weight:400;font-size:1.125rem;line-height:1.75rem">
          <td width="24" align="center" valign="top"><span style="font-size:1.875rem;line-height:1.5rem"> •</span>
          </td>
          <td align="left" valign="top">Name: ${data?.studentName}</td>
        </tr>
        <tr style="color:rgb(52,64,84);font-weight:400;font-size:1.125rem;line-height:1.75rem">
          <td width="24" align="center" valign="top"><span style="font-size:1.875rem;line-height:1.5rem"> •</span>
          </td>
          <td align="left" valign="top">Date: ${data?.date}</td>
        </tr>
        <tr style="color:rgb(52,64,84);font-weight:400;font-size:1.125rem;line-height:1.75rem">
          <td width="24" align="center" valign="top"><span style="font-size:1.875rem;line-height:1.5rem"> •</span>
          </td>
          <td align="left" valign="top">Time: ${data?.timeSlots}</td>
        </tr>
        <tr style="color:rgb(52,64,84);font-weight:400;font-size:1.125rem;line-height:1.75rem">
          <td width="24" align="center" valign="top"><span style="font-size:1.875rem;line-height:1.5rem"> •</span>
          </td>
          <td align="left" valign="top">Duration: ${data?.timeSlots}</td>
        </tr>
      </table>
      <p></p>
      <p data-id="react-email-text"
        style="font-size:1.125rem;line-height:1.75rem;margin:16px 0;color:rgb(52,64,84);font-weight:400;margin-bottom:0px">
        Best regards,<br />Support Team</p>
    </td>
  </tr>
</tbody>
</table>`
}
